import { render, staticRenderFns } from "./_DisciplinaFormAdicionar.vue?vue&type=template&id=079e8e7c&scoped=true"
import script from "./_DisciplinaFormAdicionar.vue?vue&type=script&lang=ts"
export * from "./_DisciplinaFormAdicionar.vue?vue&type=script&lang=ts"
import style0 from "./_DisciplinaFormAdicionar.vue?vue&type=style&index=0&id=079e8e7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079e8e7c",
  null
  
)

export default component.exports